import { useEffect, useState } from 'react';
import useWorkplaceTermItems from './useWorkplaceTermItems';

export default function useCapitation(workplaceId: string) {
	const [isAllowed, setIsAllowed] = useState(false);
	const { fieldOfCare } = useWorkplaceTermItems(workplaceId);

	useEffect(() => {
		if (!fieldOfCare) return;
		setIsAllowed(['001', '002', '603', '014'].includes(fieldOfCare));
	}, [fieldOfCare]);

	return {
		isCapitationAllowed: isAllowed,
	};
}
